import { Chip as MuiChip } from "@mui/material";

const PATCH_FLAG = "__safeOnClickPatchApplied";

if (MuiChip && !MuiChip[PATCH_FLAG] && typeof MuiChip.render === "function") {
  const originalRender = MuiChip.render;

  MuiChip.render = function SafeMuiChipRender(incomingProps, ref) {
    const props =
      incomingProps && typeof incomingProps === "object"
        ? { ...incomingProps }
        : incomingProps;

    if (props && typeof props === "object") {
      const hasSafeOnClick = typeof props.onClick === "function";
      const hasSafeOnDelete = typeof props.onDelete === "function";

      if ("onClick" in props && !hasSafeOnClick) {
        props.onClick = undefined;
      }

      if ("onDelete" in props && !hasSafeOnDelete) {
        props.onDelete = undefined;
      }

      if (props.clickable && !hasSafeOnClick && !hasSafeOnDelete) {
        props.clickable = false;
      }
    }

    return originalRender(props, ref);
  };

  MuiChip[PATCH_FLAG] = true;
}
